import script from "./ResumeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResumeCard.vue?vue&type=script&setup=true&lang=js"

import "./ResumeCard.vue?vue&type=style&index=0&id=0c8a7293&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c8a7293"]])

export default __exports__